import SeoHead from "../components/SeoHead";
import "../styles/policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <SeoHead
        title="Privacy Policy"
        description="Privacy policy for MohamedGad.com, including contact form data, visitor analytics, cookies, and user choices."
        canonical="https://www.mohamedgad.com/privacy-policy"
      />

      <section className="policy-hero">
        <p className="eyebrow">Privacy</p>
        <h1>Privacy Policy</h1>
        <p>
          MohamedGad.com publishes original articles, project notes, and professional
          information about AI, data science, transportation analytics, and
          operations. This policy explains what information may be collected and
          how it is used.
        </p>
        <p className="policy-updated">Last updated: July 26, 2026</p>
      </section>

      <section className="policy-section">
        <h2>Information this site collects</h2>
        <p>
          If you use the contact form, the site collects the name, email address,
          subject, and message you choose to submit so I can respond to your
          request. The site may also collect basic technical analytics such as page
          URL, browser type, device type, country-level location, referral source,
          and engagement time to understand site performance and improve content.
        </p>
      </section>

      <section className="policy-section">
        <h2>Cookies and similar technologies</h2>
        <p>
          The site may use browser storage and cookies for preferences, analytics,
          and security.
        </p>
        <p>
          You can manage cookies in your browser settings.
        </p>
      </section>

      <section className="policy-section">
        <h2>How information is used</h2>
        <p>
          Submitted contact information is used to reply to messages. Analytics
          information is used to maintain the website, understand which content is
          useful, detect technical problems, and improve the reading experience.
          Information is not sold.
        </p>
      </section>

      <section className="policy-section">
        <h2>Third-party services</h2>
        <p>
          The site may link to third-party sites such as LinkedIn, GitHub, Google,
          cited research sources, and project resources. Those sites are governed
          by their own policies.
        </p>
      </section>

      <section className="policy-section">
        <h2>Your choices</h2>
        <p>
          You can avoid submitting contact form information, clear cookies through
          your browser, block third-party cookies, or contact me to request removal
          of a message you previously submitted through the contact form.
        </p>
      </section>

      <section className="policy-section">
        <h2>Contact</h2>
        <p>
          For privacy questions, email{" "}
          <a href="mailto:mohamed@mohamedgad.com">mohamed@mohamedgad.com</a>.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
